'use client';

import { __awaiter, __generator, __assign } from '../../../_virtual/_tslib.js';
import React__default from 'react';
import Form from '../../../Form/index.js';
import Col from '../../../LayoutSystem/Col.js';
import Row from '../../../LayoutSystem/Row.js';
import { useTranslate } from '../../../Contexts/translator/index.js';
import Input from '../../../Input/index.js';
import { useOnBoarding } from '../../context/index.js';
import InputYOE from '../../../InputYOE/index.js';
import { INTERNSHIP_ID, FRESHER_ID, DEFAULT_MIN_SALARY, DEFAULT_MAX_SALARY, educations } from '../../const.js';
import MultipleRadio from '../../../MultipleRadio/index.js';
import { ELanguage } from '../../../Utils/constants.js';
import CompanyIndustry from '../../../CompanyIndustry/index.js';
import { updateBasicInfo } from '../../../services/resumes/index.js';
import { Title } from '../Title.js';

var BasicInfo = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), baseMsUrl = _a.baseMsUrl, accessToken = _a.accessToken, jobLevels = _a.jobLevels, categories = _a.categories, industries = _a.industries, lang = _a.lang, formResumeInfo = _a.formResumeInfo, setFormResumeInfo = _a.setFormResumeInfo, setIsLoading = _a.setIsLoading;
    var validator = Form.validator(t);
    var rules = {
        jobTitle: validator.string().require().noNumberAndEmail().noSpecialCharsForJobTitle().generate(),
        currentJobFunction: validator.string().require().generate(),
        currentIndustries: validator
            .array()
            .custom(function (value) {
            if (!value || (value === null || value === void 0 ? void 0 : value.length) < 1) {
                return false;
            }
            return true;
        }, t('This field is required.'))
            .generate(),
        currentSalary: validator
            .number()
            .custom(function (value) {
            if (!parseInt(value)) {
                return false;
            }
            return true;
        }, t('This field is required.'))
            .generate(),
        jobLevelId: validator.string().require().generate(),
        yearsExperience: validator
            .number()
            .custom(function (value, watch) {
            var isHightLevel = ![INTERNSHIP_ID, FRESHER_ID].includes(watch.jobLevelId);
            var isValid = !isHightLevel || (value && isHightLevel);
            return isValid;
        }, t('This field is required.'))
            .generate(),
        highestDegreeId: validator.string().require().generate()
    };
    var handleUploadResumeInfo = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var body, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!values)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = __assign(__assign({}, values), { salary: Number(values.salary), currentSalary: Number(values.currentSalary) });
                    return [4 /*yield*/, updateBasicInfo(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken !== null && accessToken !== void 0 ? accessToken : '', body, lang)];
                case 2:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.meta.code) === 200) {
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setIsLoading(false);
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React__default.createElement(Form, { initialValues: formResumeInfo, onSubmit: function (values) { return handleUploadResumeInfo(values); }, getCurrentValues: function (values) {
            setFormResumeInfo(values);
        } },
        React__default.createElement(Row, { gutter: [16, 24], justify: 'center', align: 'middle' },
            React__default.createElement(Col, null,
                React__default.createElement(Title, { title: t('Share a bit about who you are'), subTitle: t("This information plays a key role in introducing you to employers, and it's editable at any time.") })),
            React__default.createElement(Col, { xs: 24, md: 12 },
                React__default.createElement(Row, { gutter: [16, 24], justify: 'center', align: 'middle' },
                    React__default.createElement(Form.Item, { name: 'jobTitle', rules: rules.jobTitle }, function (field) { return (React__default.createElement(Col, { xs: 24, ref: field.setItemRef },
                        React__default.createElement(Form.Label, null, t('Job title')),
                        React__default.createElement(Input, { type: 'text', placeholder: t('Enter your job title'), value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 80 }),
                        React__default.createElement(Form.Error, null))); }),
                    React__default.createElement(Form.Item, { name: 'currentJobFunction', rules: rules.currentJobFunction }, function (field) {
                        return (React__default.createElement(Col, { xs: 24, ref: field.setItemRef },
                            React__default.createElement(Form.Label, null, t('Current job function')),
                            React__default.createElement(MultipleRadio, { options: categories !== null && categories !== void 0 ? categories : [], name: 'jobLevelId', placeholder: t('Please select...'), value: field.value, onBlur: field.onBlur, onChange: function (value) { return field.onChange(value.value); }, hasError: field.isError, dropdown: {
                                    maxHeight: '330px',
                                    isSearchable: true,
                                    emptyText: t('No Result Found'),
                                    searchBoxPlaceholder: t('Search')
                                } }),
                            React__default.createElement(Form.Error, null)));
                    }),
                    React__default.createElement(Form.Item, { name: 'currentIndustries', rules: rules.currentIndustries }, function (field) {
                        var _a;
                        return (React__default.createElement(Col, { xs: 24, ref: field.setItemRef },
                            React__default.createElement(Form.Label, null, t('Current industry')),
                            React__default.createElement(CompanyIndustry, { type: 'multiple-select', options: (_a = industries) !== null && _a !== void 0 ? _a : [], value: field.value, onChange: function (value) { return field.onChange(value); }, onBlur: field.onBlur, hasError: field.isError, langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI, isMobile: false, dropdownStyle: { width: '100%' } }),
                            React__default.createElement(Form.Error, null)));
                    }),
                    React__default.createElement(Form.Item, { name: 'currentSalary', rules: rules.currentSalary }, function (field) {
                        return (React__default.createElement(Col, { xs: 24 },
                            React__default.createElement(Form.Label, { require: true }, t('Current salary')),
                            React__default.createElement(InputYOE, { postfixText: t('USD/month'), placeholder: t('Enter your current salary'), defaultValue: Number(field.value) > 0 ? field.value : '', isError: field.isError, options: {
                                    min: DEFAULT_MIN_SALARY,
                                    max: DEFAULT_MAX_SALARY,
                                    canBeEmpty: true
                                }, typeInput: 'text', onChange: field.onChange, onBlur: field.onBlur }),
                            React__default.createElement(Form.Error, null)));
                    }),
                    React__default.createElement(Form.Item, { name: 'jobLevelId', rules: rules.jobLevelId }, function (field) {
                        return (React__default.createElement(Col, { xs: 24 },
                            React__default.createElement(Form.Label, { require: true }, t('Current job level')),
                            React__default.createElement(MultipleRadio, { options: jobLevels !== null && jobLevels !== void 0 ? jobLevels : [], name: 'level-list', placeholder: t('Please select...'), value: field.value, onChange: function (item) { return field.onChange(item.value); }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                                    maxHeight: '250px',
                                    isSearchable: true,
                                    emptyText: t('No Result Found'),
                                    searchBoxPlaceholder: t('Search')
                                } }),
                            React__default.createElement(Form.Error, null)));
                    }),
                    React__default.createElement(Form.Item, { name: 'yearsExperience', watch: ['jobLevelId'], rules: rules.yearsExperience }, function (field) {
                        var _a;
                        var isHightLevel = ![INTERNSHIP_ID, FRESHER_ID].includes((_a = field.watch) === null || _a === void 0 ? void 0 : _a.jobLevelId);
                        return (React__default.createElement(Col, { xs: 24, ref: field.setItemRef },
                            React__default.createElement(Form.Label, { require: isHightLevel }, t('Years of experience')),
                            React__default.createElement(InputYOE, { onChange: function (value) { return field.onChange(parseInt(value)); }, onBlur: function () { return field.onBlur(); }, postfixText: Number(field.value) > 1 ? t('Years') : t('Year'), defaultValue: Number(field.value) > 0 ? field.value : '', isError: !isHightLevel ? false : field.isError, placeholder: t('Enter your year experience') }),
                            React__default.createElement(Form.Error, { disable: !isHightLevel })));
                    }),
                    React__default.createElement(Form.Item, { name: 'highestDegreeId', rules: rules.highestDegreeId }, function (field) {
                        return (React__default.createElement(Col, { xs: 24, ref: field.setItemRef },
                            React__default.createElement(Form.Label, null, t('Highest education')),
                            React__default.createElement(MultipleRadio, { options: educations.map(function (education) { return ({
                                    id: education.id,
                                    name: lang === ELanguage.EN ? education.nameEn : education.name
                                }); }), name: 'highestDegree', placeholder: t('Please select...'), value: field.value, onChange: function (value) { return field.onChange(value.value); }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                                    maxHeight: '330px',
                                    isSearchable: true,
                                    emptyText: t('No Result Found'),
                                    searchBoxPlaceholder: t('Search')
                                } }),
                            React__default.createElement(Form.Error, null)));
                    }))))));
};

export { BasicInfo as default };
//# sourceMappingURL=index.js.map
